import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    name: yup
        .string('*Enter your name!')
        .required('*Name is required')
        .min(2,'*Name is too short!'),
        
    lastName: yup
        .string('*Enter your name!')
        .required('*Last name is required')
        .min(2,'*Last name is too short!'),
    age: yup
        .number('*Enter your age!')
        .required('Age is required')
        .min(12,'*Your age must be from 12 to 90!')
        .max(90,'*Your age must be from 12 to 90!'),
    address: yup
        .string()
        .required('*Address is required')
        .min(2,'*Address is too short!'),
    phoneNumber: yup
        .number('*Enter your phone number!')
        .required('*Phone number is required'),
    email: yup
        .string('*Enter your email!')
        .required('*Email is required')
        .email('*Invalid email address!')
  });

